module.exports = __webpack_public_path__ + "static/img/starter_plan_icon.8ac6f0b5.svg";